module.exports = __webpack_public_path__ + "img/Rectangle 62.8308fb37.jpg";